// extracted by mini-css-extract-plugin
export default {"checkbox-container":"PmrChecboxRefiner_checkbox-container__xC4gT"};